import { create } from 'zustand';

import type {
  TrackIDChangeRequestStoreActions,
  TrackIDChangeRequestStoreState,
} from '@/type';

const INIT_STATE: TrackIDChangeRequestStoreState = {
  linkedFrameList: [],
  nextTrackID: null,
  requestUserID: null,
  targetTrackID: null,
};

const useTrackIDChangeRequestStore = create<
  TrackIDChangeRequestStoreState & TrackIDChangeRequestStoreActions
>((set, get) => {
  return {
    ...INIT_STATE,

    clearRequest() {
      set({ ...INIT_STATE });
    },

    hasRequest() {
      return !!(
        get().nextTrackID &&
        get().requestUserID &&
        get().targetTrackID
      );
    },

    removeLinkedFrame(frameSeq) {
      set(state => ({
        linkedFrameList: state.linkedFrameList.filter(
          frame => frame.frameSeq !== frameSeq,
        ),
      }));
    },

    setLinkedFrameList(payload) {
      set({
        linkedFrameList: payload,
      });
    },

    setRequest(payload) {
      set({
        linkedFrameList: [],
        nextTrackID: payload.nextTrackID,
        requestUserID: payload.requestUserID,
        targetTrackID: payload.targetTrackID,
      });
    },
  };
});

export default useTrackIDChangeRequestStore;
